import {Howl, Howler} from 'howler';
export default class AudioManager
{
    constructor()
    {
        this.BASE_URL = "https://savoirs-legendaires.s3.amazonaws.com/audios/";
        this.audios = [];
        this.callback = {}
        this.playSingle = [];

        this.loadJson();
    }

    async loadJson ()
    {
        let strURL = this.BASE_URL + "audio.json";
        let response = await fetch(strURL);

        this.json = await response.json();
        await this.prepareHowler();

    }


    async prepareHowler ()
    {
        console.log("prepareHowler")
        console.log(this.json);
        for (let strKey in this.json)
        {
            let obj = this.json[strKey];

            let strSrc = obj.sources.split("/").pop();
            let sprite = obj.sprite;

            let objAudio = {ready: false};

            objAudio.type = strKey;
            objAudio.audio = new Howl({
                                          src:     [this.BASE_URL + strSrc],
                                          preload: false,
                                          html5:   false,
                                          sprite
                                      });

            objAudio.audio.once ('load', () => this.onLoad(objAudio));
            objAudio.audio.on ('end', this.onSoundEnd.bind(this));

            objAudio.audio.load();


            this.audios.push (objAudio);
            console.log(strKey, obj)
        }
    }

    onLoad (objAudio)
    {
        objAudio.ready = true;

        console.log("%cAudioManager::onLoad", "background-color:purple");
    }

    onSoundEnd (id)
    {
        console.log("onSoundEnd", id)
        console.log(this.callback);

        if (this.callback[id])
        {
            let obj = this.callback[id];
            obj.callback(obj.sfx);
            delete this.callback[id]
        }
    }

    getAudio (strType)
    {
        return this.audios.find( o => o.type === strType)
    }

    playOne (sfx, callback)
    {
        let id = this.playSound(sfx, callback)
        return id;
    }
    play (arr)
    {
        console.log("play", arr);

        let arrPlaying = [];

        for (let i = 0; i < arr.length; i++)
        {
            let sfx = arr[i];

            let id = this.playSound(sfx)

            arrPlaying.push(id);
            console.log(sfx);
        }

        return arrPlaying;
    }

    reset ()
    {
        this.playSingle = [];
    }
    stop (id)
    {
        let type = "SFX";
        let objAudio = this.getAudio(type);

        objAudio.audio.stop(id);

        this.playSingle = this.playSingle.filter ( s => s !== id);
    }
    playSound (args, callback)
    {
        args = Object.assign({loop:false}, args);

        let {name, loop} = args;

        if (!name || name === "")
            return;

        let type = "SFX";
        let objAudio = this.getAudio(type);



        if (loop === 1)
        {
            if (this.playSingle.includes(name))
            {
                return 0;
            }
        }

        let id = objAudio.audio.play(name);

        if (callback)
        {
            this.callback[id] = {callback, sfx: args};

        }

        if (loop === 1)
        {

            objAudio.audio.loop(true, id);
            this.playSingle.push(name);

        }



        return id;
    }
}
